<template>
  <div id="register-product">

    <div class="form-input-container">

      <div style="display: inline-block; width: calc(50% - 10px); margin-right: 10px;" class="form-input-section">
        <span>Nome:</span>
        <input v-model="product.name" type="text" placeholder="Digite o nome do produto"/>
      </div>

      <div style="display: inline-block; width: calc(25% - 20px); margin: 0 10px;" class="form-input-section">
        <span>SKU:</span>
        <input v-model="product.sku" type="text" placeholder="Digite o SKU do produto"/>
      </div>

      <div style="display: inline-block; width: calc(25% - 10px); margin-left: 10px;" class="form-input-section">
        <span>Tipo:</span>
        <input v-model="product.type" type="text" placeholder="Digite o Tipo do produto"/>
      </div>

      <div style="display: inline-block; width: calc(33% - 10px); margin-right: 10px;" class="form-input-section">
        <span>Valor Unitário:</span>
        <input v-model="product.unit_value" type="number" placeholder="Digite o Valor Unitário do produto"/>
      </div>

      <div style="display: inline-block; width: calc(33% - 20px); margin: 0 10px;" class="form-input-section">
        <span>Unidade:</span>
        <input v-model="product.unit" type="text" placeholder="Digite a Unidade do produto"/>
      </div>

      <div style="display: inline-block; width: 33%; margin-left: 10px;" class="form-input-section">
        <span>Preço:</span>
        <input v-model="product.price" type="number" placeholder="Digite o Preço do produto"/>
      </div>

      <div style="display: inline-block; width: calc(70% - 10px); margin-right: 10px;" class="form-input-section">
        <span>Empresa:</span>
        <select v-model="product.company_id" >
          <option v-for="company in companies" :value="company.id" selected>{{company.name}}</option>
        </select>
      </div>

      <div style="display: inline-block; width: calc(30% - 10px); margin-left: 10px;" class="form-input-section">
        <span>Ativo:</span>
        <label class="switch">
          <input v-model="product.is_active" type="checkbox">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="form-input-actions">
      <AppButton @click="saveProduct()" label="Salvar" />
    </div>

  </div>
</template>

<script src="./RegisterProduct.js" />
<style scoped src="./RegisterProduct.scss" lang="scss" />